import KyMethod from "@repositories/KyMethod"

export default class CheckoutRepositories extends KyMethod {
  async checkRawVoucher(code: string) {
    return this._getProtectedData(`/checkout/redeem-voucher/${code}`)
  }

  async redeemRawVoucher(id: string, code: string) {
    return this._protectedCrudMethod(`/checkout/redeem-voucher`, {
      body: {
        cart: [
          {
            product: {
              id,
            },
            code,
          },
        ],
      },
    })
  }

  async getRawPaymentMethods(id: string) {
    return this._getProtectedData(`/service/${id}/payment`)
  }

  async checkRawDiscount(id: string, code: string) {
    return this._protectedCrudMethod(`/service/${id}/discount`, { body: { code } })
  }

  async rawCheckout(id: string) {
    return this._protectedCrudMethod(`/checkout/order`, {
      body: {
        cart: [
          {
            type: "LEARNING",
            product: {
              id,
            },
          },
        ],
      },
    })
  }

  async rawSubmitGetInfo(checkoutId: string, info_from: string[]) {
    return this._protectedCrudMethod(`/checkout/order/${checkoutId}/info`, {
      body: { info_from },
    })
  }
  async rawSubmitPromo(checkoutId: string, discount_code: string) {
    return this._protectedCrudMethod(`/checkout/order/${checkoutId}/discount`, {
      body: { discount_code },
    })
  }

  protected async submitRawPayment({
    checkoutId,
    payment_method,
  }: {
    checkoutId: string
    payment_method: string
  }) {
    return this._protectedCrudMethod(`/checkout/order/${checkoutId}/payments`, {
      body: {
        payment_method,
      },
    })
  }

  protected async getRawCheckoutDetail(orderNumber: string) {
    return this._getProtectedData(`/checkout/order/${orderNumber}`)
  }
}
